import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const MMAComplicationsService = {
    LoadData,
    SaveData
};
function LoadData(pid, loggedInUserId) {
    return WebServiceWrapper.Get(`/mmaComplication/GetMMAComplicationData?patientId=${pid}&&loggedInUserId=${loggedInUserId}&isAdmin=${IsAdmin()}`);
}
function SaveData(payload) {
    return WebServiceWrapper.Post("/mmaComplication/SaveMMAComplicationData", payload);
}
